module.exports = __webpack_public_path__ + "img/shouyeimage.64e90fa8.png";